import React, { useRef, useEffect, useState } from "react";
import { FaPercentage } from "react-icons/fa";
import { MdCreditScore } from "react-icons/md";

import { MdOutlineSpeakerPhone } from "react-icons/md";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import {
  getProfile,
  listTenantInvoices,
  createTenantPayment,
  createSTK,
  checkSTKStatus,
} from "../../../../redux/slices/sliceActions";
import PaymentCard from "./ExpandablePaymentCard";
import PartialPaymentPage from "./PartialPaymentPage";
import { FaMoneyBillWave } from "react-icons/fa";

const PayWindowModal = ({ setShowPay, fieldToShow }) => {
  //data fetched from the store
  const dispatch = useDispatch();
  const { user, profile } = useSelector((state) => state.landlordslice);
  const token = user?.accessToken;
  const id = user?.data?.user?.user_id;

  const [invoicesReceived, setInvoicesReceived] = useState([]);
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    console.log(user);
    const details = {
      user_id: user?.data?.user?.user_id,
      token: user?.accessToken,
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
    };

    dispatch(listTenantInvoices({ details })).then((res) => {
      setInvoicesReceived(res?.payload?.data?.invoices);
    });
  }, [user]);

  useEffect(() => {
    if (invoicesReceived?.length > 0) {
      setInvoices(transformInvoices(invoicesReceived));
      console.log("Invoices:", invoices);
    }
  }, [invoicesReceived]);

  const modalRef = useRef();
  const [selectedPaymentType, setSelectedPaymentType] = useState(null);
  const [isClosing, setIsClosing] = useState(false);

  const [isSmallScreen, setIsSmallScreen] = useState(false);
  useEffect(() => {
    if (window.innerHeight < 896) {
      setIsSmallScreen(true);
    }
  }, []);

  const payWindowContainer = {
    position: "fixed",
    bottom: "0",
    left: "0",
    zIndex: "100",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "end",
    transition: "opacity 1s ease",
    opacity: isClosing ? 0 : 1,
  };

  const payWindow = {
    position: "relative",
    boxShadow: "0px -20px 30px 0px rgba(0,0,0,0.1)",
    display: "flex",
    zIndex: "1001",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "20px 20px 0px 0px",
    width: "100vw",
    maxHeight: isSmallScreen ? "120vh" : "80vh",
    // paddingBottom: "60px",
    backgroundColor: "#FBFBFD",
    transform: "translateY(100%)",
    transition: "transform 1s",
    animation: isClosing ? "slideDown 1s forwards" : "slideUp 1s forwards",
    //overflow
    overflowY: "scroll",
  };

  const shape = {
    backgroundColor: "#192A3A",
    marginTop: "20px",
    width: "50px",
    height: "10px",
    borderRadius: "40px",
  };
  const titleAndText = {
    color: "#192A3A",
    marginTop: "10px",
    fontSize: "20px",
    fontFamily: "Poppins, sans-serif",
    textAlign: "center",
  };
  const text = {
    color: "#A8B4CC",
    marginTop: "0px",
    fontSize: "15px",
  };
  const paymentInformationBox = {
    backgroundColor: "white",
    borderRadius: "15px",
    width: "90%",
    paddingBottom: "20px",
    marginTop: "20px",
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.28)",
  };
  const paymentInformationTitle = {
    color: "#192A3A",
    fontSize: "16px",
    fontFamily: "Poppins, sans-serif",
    margin: "10px 20px 5px 20px",
    fontWeight: "400",
  };
  const paymentInformationDetails = {
    color: "#192A3A",
    fontSize: "14px",
    margin: "5px 20px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: "200",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };
  const amountStyle = {
    fontWeight: "500",
  };
  const borderLines = {
    width: "90%",
    height: "1px",
    backgroundColor: "rgba(168, 180, 204, 0.5)",
    margin: "10px 20px",
  };
  const totalPayableAmount = {
    color: "#192A3A",
    fontSize: "25px",
    fontWeight: "600",
  };
  const paymentTypeSelect = {
    backgroundColor: "white",
    borderRadius: "10px",
    marginTop: "20px",
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.28)",
    width: "90%",
    height: "50px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer", // Indicate clickable area
  };

  const icon = {
    marginLeft: "10px",
  };
  const iconTwo = {
    marginLeft: "20px",
    marginTop: "5px",
  };
  const paymentSelectTitleAndText = {
    fontSize: "20px",
    textAlign: "center",
  };
  const paymentSelectText = {
    fontSize: "14px",
    color: "#A8B4CC",
  };
  const radialSelect = {
    marginRight: "10px",
    width: "20px",
    height: "20px",
  };
  const radialSelectTwo = {
    marginRight: "20px",
    width: "20px",
    height: "20px",
  };
  const continueButton = {
    marginTop: "20px",
    width: "90%",
    height: "40px",
    borderRadius: "10px",
    marginBottom: "20px",
    fontSize: "18px",
    color: "white",
    border: "none",
    backgroundColor: "#192A3A",
  };

  // Close the modal when clicking outside the modal
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && modalRef.current === event.target) {
        setIsClosing(true);
        setTimeout(() => setShowPay(false), 800);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowPay]);
  // console.log("the incoice", invoices);
  const InvoiceData = {
    invoiceNumber: invoices[0]?.id,
    dueDate: invoices[0]?.dueDate,
    details: {
      Rent: Number(invoices[0]?.rent || 0),
      Water: Number(invoices[0]?.water || 0),
      Arrears: Number(invoices[0]?.arrears || 0),
      Garbage: Number(invoices[0]?.garbage || 0),
      UnpaidDeposit: Number(invoices[0]?.unpaid_deposit),
      Fees: invoices[0]?.otherCharges - invoices[0]?.service_charge || 0,
      Total: invoices[0]?.totalAmount,
    },
    transactionId: 1234567890,
  };

  //states to select type is selected
  const [paymentTypeSelected, setPaymentTypeSelected] = useState(false);

  //function to set the payment type selected by the user(full or partial)
  const handlePaymentSelect = (value) => {
    setSelectedPaymentType(value);
  };

  const handleContinueToPayment = () => {
    if (!selectedPaymentType) {
      alert("Please select a payment type to continue");
      return;
    }
    console.log("selected payment type", selectedPaymentType);
    setPaymentTypeSelected(true);
  };

  //states to manage which page is showing (payment method page, or edit page)
  const [paymentMethodPage, setPaymentMethodPage] = useState(false);
  const [partialPaymentPage, setPartialPaymentPage] = useState(false);

  //functionality to select the page to show
  useEffect(() => {
    if (!paymentTypeSelected) return;
    if (selectedPaymentType === "fullPayment") {
      console.log("payment in full page", invoicesReceived[0]);
      setPaymentMethodPage(true);
      return;
    } else {
      console.log("partial payments page");
      setPartialPaymentPage(true);
    }
  }, [paymentTypeSelected]);

  //Edit payment page functionality
  //states to manage the required information for a payment
  const [partialPaymentDetails, setPartialPaymentDetails] = useState({});
  const onPartialPaymentFormComplete = (data) => {
    console.log("partial payment data", data);
    setPartialPaymentDetails(data);
    setPartialPaymentPage(false);
    setPaymentMethodPage(true);
  };

  //functionality for payment method page
  //which method selected (Mpesa, Bank Transfer, Cash)
  const [paymentMethodSelected, setPaymentMethodSelected] = useState(false);

  const handlePaymentMethodSelect = (value) => {
    setPaymentMethodSelected(value);
  };

  useEffect(() => {
    console.log("payment method selected", paymentMethodSelected);
  }, [paymentMethodSelected]);

  //Values recorded on payment method page
  const [paymentReference, setPaymentReference] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [paymentNarration, setPaymentNarration] = useState("");
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedDate, setSelectedDate] = useState(new Date().getDate());
  const [paymentDate, setPaymentDate] = useState("");

  // useEffect(() => {
  //   const formatedDate = formatDate(selectedYear, selectedMonth, selectedDate)
  //   setPaymentDate(formatedDate);

  // }, [selectedDate, selectedMonth, selectedYear]);

  //making the actual payment
  const makePayment = async () => {
    if (!paymentMethodSelected) {
      return;
    }
    setSubmissionState("loading");
    let newPaymentDetails;
    if (!fieldToShow) {
      console.log(InvoiceData.details);
      if (selectedPaymentType === "fullPayment") {
        newPaymentDetails = {
          houseId: user?.data?.house?.house_id,
          houseNumber: user?.data?.house?.house_number,
          paymentMethod: paymentMethodSelected || "CASH",
          paymentReference: paymentReference || "",
          paymentNarration: paymentNarration || "",
          // payerTransactionReference: paymentDetails.referenceNumber || "",
          paymentDate: paymentDate,
          month: invoicesReceived[0].month || "",
          year: invoicesReceived[0].year || "",
          rentAmount:
            invoicesReceived[0].rent || invoicesReceived[0].remaining_rent || 0,
          waterAmount:
            invoicesReceived[0].water ||
            invoicesReceived[0].remaining_water ||
            0,
          garbageAmount:
            invoicesReceived[0].garbage ||
            invoicesReceived[0].remaining_garbage ||
            0,
          serviceFeeAmount:
            invoicesReceived[0].service_charge ||
            invoicesReceived[0].remaining_service_charge ||
            0,
          lateFeeAmount:
            invoicesReceived[0].late_fee ||
            invoicesReceived[0].remaining_late_fee ||
            0,
          arrearsAmount:
            invoicesReceived[0].remaining_arrears ||
            invoicesReceived[0].remaining_arrears ||
            0,
          unpaidDepositAmount:
            invoicesReceived[0].unpaid_deposit ||
            invoicesReceived[0].remaining_unpaid_deposit ||
            0,
        };
      } else {
        console.log("partial payments data", partialPaymentDetails);

        newPaymentDetails = {
          houseId: user?.data?.house?.house_id,
          houseNumber: user?.data?.house?.house_number,
          paymentMethod: paymentMethodSelected || "CASH",
          paymentReference: paymentReference || "",
          paymentNarration: paymentNarration || "",
          // payerTransactionReference: paymentDetails.referenceNumber || "",
          paymentDate: paymentDate,
          month: invoicesReceived[0].month || "",
          year: invoicesReceived[0].year || "",
          rentAmount: partialPaymentDetails.details.Rent || 0,
          waterAmount: partialPaymentDetails.details.Water || 0,
          garbageAmount: partialPaymentDetails.details.Garbage || 0,
          serviceFeeAmount: partialPaymentDetails.details.ServiceFees || 0,
          lateFeeAmount: partialPaymentDetails.details.LateFee || 0,
          arrearsAmount: partialPaymentDetails.details.Arrears || 0,
          unpaidDepositAmount: partialPaymentDetails.UnpaidDeposit || 0,
        };
      }
    } else {
      if (selectedPaymentType === "fullPayment") {
        console.log("fields chosen", fieldToShow);

        //switch case to set new payment values to 0 except for the chosen field
        switch (fieldToShow[0]) {
          case "rent":
            newPaymentDetails = {
              houseId: user?.data?.house?.house_id,
              houseNumber: user?.data?.house?.house_number,
              paymentMethod: paymentMethodSelected || "CASH",
              paymentReference: paymentReference || "",
              paymentNarration: paymentNarration || "",
              // payerTransactionReference: paymentDetails.referenceNumber || "",
              paymentDate: paymentDate,
              month: invoicesReceived[0].month || "",
              year: invoicesReceived[0].year || "",
              rentAmount:
                invoicesReceived[0].rent ||
                invoicesReceived[0].remaining_rent ||
                0,
              waterAmount: 0,
              garbageAmount: 0,
              serviceFeeAmount: 0,
              lateFeeAmount: 0,
              arrearsAmount: 0,
              unpaidDepositAmount: 0,
            };
            break;
          case "water":
            newPaymentDetails = {
              houseId: user?.data?.house?.house_id,
              houseNumber: user?.data?.house?.house_number,
              paymentMethod: paymentMethodSelected || "CASH",
              paymentReference: paymentReference || "",
              paymentNarration: paymentNarration || "",
              // payerTransactionReference: paymentDetails.referenceNumber || "",
              paymentDate: paymentDate,
              month: invoicesReceived[0].month || "",
              year: invoicesReceived[0].year || "",
              rentAmount: 0,
              waterAmount:
                invoicesReceived[0].water ||
                invoicesReceived[0].remaining_water ||
                0,
              garbageAmount: 0,
              serviceFeeAmount: 0,
              lateFeeAmount: 0,
              arrearsAmount: 0,
              unpaidDepositAmount: 0,
            };
            break;
          case "garbage":
            newPaymentDetails = {
              houseId: user?.data?.house?.house_id,
              houseNumber: user?.data?.house?.house_number,
              paymentMethod: paymentMethodSelected || "CASH",
              paymentReference: paymentReference || "",
              paymentNarration: paymentNarration || "",
              // payerTransactionReference: paymentDetails.referenceNumber || "",
              paymentDate: paymentDate,
              month: invoicesReceived[0].month || "",
              year: invoicesReceived[0].year || "",
              rentAmount: 0,
              waterAmount: 0,
              garbageAmount:
                invoicesReceived[0].garbage ||
                invoicesReceived[0].remaining_garbage ||
                0,
              serviceFeeAmount: 0,
              lateFeeAmount: 0,
              arrearsAmount: 0,
              unpaidDepositAmount: 0,
            };
            break;
          case "serviceCharge":
            newPaymentDetails = {
              houseId: user?.data?.house?.house_id,
              houseNumber: user?.data?.house?.house_number,
              paymentMethod: paymentMethodSelected || "CASH",
              paymentReference: paymentReference || "",
              paymentNarration: paymentNarration || "",
              // payerTransactionReference: paymentDetails.referenceNumber || "",
              paymentDate: paymentDate,
              month: invoicesReceived[0].month || "",
              year: invoicesReceived[0].year || "",
              rentAmount: 0,
              waterAmount: 0,
              garbageAmount: 0,
              serviceFeeAmount:
                invoicesReceived[0].service_charge ||
                invoicesReceived[0].remaining_service_charge ||
                0,
              lateFeeAmount: 0,
              arrearsAmount: 0,
              unpaidDepositAmount: 0,
            };
            break;
          case "arrears":
            newPaymentDetails = {
              houseId: user?.data?.house?.house_id,
              houseNumber: user?.data?.house?.house_number,
              paymentMethod: paymentMethodSelected || "CASH",
              paymentReference: paymentReference || "",
              paymentNarration: paymentNarration || "",
              // payerTransactionReference: paymentDetails.referenceNumber || "",
              paymentDate: paymentDate,
              month: invoicesReceived[0].month || "",
              year: invoicesReceived[0].year || "",
              rentAmount: 0,
              waterAmount: 0,
              garbageAmount: 0,
              serviceFeeAmount: 0,
              lateFeeAmount: 0,
              arrearsAmount:
                invoicesReceived[0].arrears ||
                invoicesReceived[0].remaining_arrears ||
                0,
              unpaidDepositAmount: 0,
            };
            break;
          case "unpaidDeposit":
            newPaymentDetails = {
              houseId: user?.data?.house?.house_id,
              houseNumber: user?.data?.house?.house_number,
              paymentMethod: paymentMethodSelected || "CASH",
              paymentReference: paymentReference || "",
              paymentNarration: paymentNarration || "",
              // payerTransactionReference: paymentDetails.referenceNumber || "",
              paymentDate: paymentDate,
              month: invoicesReceived[0].month || "",
              year: invoicesReceived[0].year || "",
              rentAmount: 0,
              waterAmount: 0,
              garbageAmount: 0,
              serviceFeeAmount: 0,
              lateFeeAmount: 0,
              arrearsAmount: 0,
              unpaidDepositAmount:
                invoicesReceived[0].unpaid_deposit ||
                invoicesReceived[0].remaining_unpaid_deposit ||
                0,
            };
        }
      } else {
        console.log("fields chosen", fieldToShow);
        console.log("the user", user);
        //switch case to set new payment values to 0 except for the chosen field
        switch (fieldToShow[0]) {
          case "rent":
            newPaymentDetails = {
              houseId: user?.data?.house?.house_id,
              houseNumber: user?.data?.house?.house_number,
              paymentMethod: paymentMethodSelected || "CASH",
              paymentReference: paymentReference || "",
              paymentNarration: paymentNarration || "",
              // payerTransactionReference: paymentDetails.referenceNumber || "",
              paymentDate: paymentDate,
              month: invoicesReceived[0].month || "",
              year: invoicesReceived[0].year || "",
              rentAmount: partialPaymentDetails.details.Rent || 0,
              waterAmount: 0,
              garbageAmount: 0,
              serviceFeeAmount: 0,
              lateFeeAmount: 0,
              arrearsAmount: 0,
              unpaidDepositAmount: 0,
            };
            break;
          case "water":
            newPaymentDetails = {
              houseId: user?.data?.house?.house_id,
              houseNumber: user?.data?.house?.house_number,
              paymentMethod: paymentMethodSelected || "CASH",
              paymentReference: paymentReference || "",
              paymentNarration: paymentNarration || "",
              // payerTransactionReference: paymentDetails.referenceNumber || "",
              paymentDate: paymentDate,
              month: invoicesReceived[0].month || "",
              year: invoicesReceived[0].year || "",
              rentAmount: 0,
              waterAmount: partialPaymentDetails.details.Water || 0,
              garbageAmount: 0,
              serviceFeeAmount: 0,
              lateFeeAmount: 0,
              arrearsAmount: 0,
              unpaidDepositAmount: 0,
            };
            break;
          case "garbage":
            newPaymentDetails = {
              houseId: user?.data?.house?.house_id,
              houseNumber: user?.data?.house?.house_number,
              paymentMethod: paymentMethodSelected || "CASH",
              paymentReference: paymentReference || "",
              paymentNarration: paymentNarration || "",
              // payerTransactionReference: paymentDetails.referenceNumber || "",
              paymentDate: paymentDate,
              month: invoicesReceived[0].month || "",
              year: invoicesReceived[0].year || "",
              rentAmount: 0,
              waterAmount: 0,
              garbageAmount: partialPaymentDetails.details.Garbage || 0,
              serviceFeeAmount: 0,
              lateFeeAmount: 0,
              arrearsAmount: 0,
              unpaidDepositAmount: 0,
            };
            break;
          case "serviceCharge":
            newPaymentDetails = {
              houseId: user?.data?.house?.house_id,
              houseNumber: user?.data?.house?.house_number,
              paymentMethod: paymentMethodSelected || "CASH",
              paymentReference: paymentReference || "",
              paymentNarration: paymentNarration || "",
              // payerTransactionReference: paymentDetails.referenceNumber || "",
              paymentDate: paymentDate,
              month: invoicesReceived[0].month || "",
              year: invoicesReceived[0].year || "",
              rentAmount: 0,
              waterAmount: 0,
              garbageAmount: 0,
              serviceFeeAmount: partialPaymentDetails.details.ServiceFees || 0,
              lateFeeAmount: 0,
              arrearsAmount: 0,
              unpaidDepositAmount: 0,
            };
            break;
          case "arrears":
            newPaymentDetails = {
              houseId: user?.data?.house?.house_id,
              houseNumber: user?.data?.house?.house_number,
              paymentMethod: paymentMethodSelected || "CASH",
              paymentReference: paymentReference || "",
              paymentNarration: paymentNarration || "",
              // payerTransactionReference: paymentDetails.referenceNumber || "",
              paymentDate: paymentDate,
              month: invoicesReceived[0].month || "",
              year: invoicesReceived[0].year || "",
              rentAmount: 0,
              waterAmount: 0,
              garbageAmount: 0,
              serviceFeeAmount: 0,
              lateFeeAmount: 0,
              arrearsAmount: partialPaymentDetails.details.Arrears || 0,
              unpaidDepositAmount: 0,
            };
            break;
          case "unpaidDeposit":
            newPaymentDetails = {
              houseId: user?.data?.house?.house_id,
              houseNumber: user?.data?.house?.house_number,
              paymentMethod: paymentMethodSelected || "CASH",
              paymentReference: paymentReference || "",
              paymentNarration: paymentNarration || "",
              // payerTransactionReference: paymentDetails.referenceNumber || "",
              paymentDate: paymentDate,
              month: invoicesReceived[0].month || "",
              year: invoicesReceived[0].year || "",
              rentAmount: 0,
              waterAmount: 0,
              garbageAmount: 0,
              serviceFeeAmount: 0,
              lateFeeAmount: 0,
              arrearsAmount: 0,
              unpaidDepositAmount: partialPaymentDetails.UnpaidDeposit || 0,
            };
            break;
        }
      }
    }

    try {
      console.log("timothy look here", newPaymentDetails?.paymentMethod);
      if (newPaymentDetails?.paymentMethod === "STK_PUSH") {
        console.log("payment method is  STK_PUSH");
        const stkResponse = await dispatch(
          createSTK({
            paymentDetails: {
              house_id: newPaymentDetails?.houseId,
              narration: newPaymentDetails?.paymentNarration,
              month: newPaymentDetails?.month,
              year: newPaymentDetails?.year,
              rent: newPaymentDetails?.rentAmount,
              water: newPaymentDetails?.waterAmount,
              garbage: newPaymentDetails?.garbageAmount,
              service_charge: newPaymentDetails?.serviceFeeAmount,
              late_fee: newPaymentDetails?.lateFeeAmount,
              arrears: newPaymentDetails?.arrearsAmount,
              unpaid_deposit: newPaymentDetails?.unpaidDepositAmount,
              phone: phoneNumber,
            },
          })
        );

        console.log("STK Response", stkResponse);

        // Extract checkout request ID and start long polling with single dispatch
        const checkoutRequestId = stkResponse?.payload?.data?.checkoutRequestId;

        if (checkoutRequestId) {
          console.log(
            "Starting short polling for checkout request:",
            checkoutRequestId
          );

          // Short polling implementation - check every 5 seconds
          const pollInterval = setInterval(async () => {
            try {
              const response = await dispatch(checkSTKStatus({ checkoutRequestId }));
              console.log("Polling response:", response);

              const responseData = response?.payload?.data;
              const isCompleted = responseData?.isCompleted;
              const isFailed = responseData?.isFailed;
              const isExpired = responseData?.isExpired;
              const shouldStopPolling = responseData?.shouldStopPolling;
              const payment = responseData?.payment;
              const failureReason = responseData?.failureReason;

              // Stop polling if the API indicates we should stop
              if (shouldStopPolling === true) {
                clearInterval(pollInterval);

                if (isCompleted === true && payment) {
                  // Payment successful - has payment data
                  console.log("Payment successful!", payment);
                  setSubmissionState("complete");

                  // Refresh profile
                  dispatch(getProfile({ userId: id })).then((res) => {
                    console.log("Profile updated after successful payment", res);
                  });

                  // Close modal after showing success
                  setTimeout(() => {
                    setIsClosing(true);
                    setTimeout(() => {
                      setSubmissionState("idle");
                    }, 1000);
                  }, 3000);
                } else if (isFailed === true || isExpired === true) {
                  // Payment failed, expired, or was cancelled
                  console.log("Payment failed:", failureReason || "Payment was not completed");
                  setFailureMessage(failureReason || "Payment was not completed. Please try again or contact support.");
                  setSubmissionState("failed");
                } else {
                  // Other failure scenarios
                  console.log("Payment failed or cancelled");
                  setFailureMessage("Payment was not completed. Please try again or contact support.");
                  setSubmissionState("failed");
                }
              }
              // If shouldStopPolling is false, continue polling (payment still pending)
            } catch (error) {
              console.error("Polling error:", error);
              clearInterval(pollInterval);
              setSubmissionState("failed");
            }
          }, 5000); // Poll every 5 seconds

          // Set a timeout to stop polling after 5 minutes (300 seconds)
          setTimeout(() => {
            clearInterval(pollInterval);
            if (submissionState === "loading") {
              console.log("Polling timeout - payment took too long");
              setSubmissionState("failed");
            }
          }, 300000); // 5 minutes timeout
        } else {
          console.error("No checkout request ID received from STK response");
          setSubmissionState("failed");
        }
      } else {
        // Handle other payment methods as before
        await dispatch(
          createTenantPayment({
            details: newPaymentDetails,
          })
        ).then((res) => {
          console.log("Payment response", res);

          dispatch(getProfile({ userId: id })).then((res) => {
            console.log("New Profile Response", res);
          });
        });

        setSubmissionState("complete");
        setTimeout(() => {
          setIsClosing(true);
          setSubmissionState("idle");
        }, 3000);
      }
    } catch (error) {
      console.error("Payment submission failed", error);
      setSubmissionState("failed");
      setTimeout(() => {
        setSubmissionState("idle");
      }, 5000);
    }

    console.log("making payment", paymentMethodSelected);
    console.log("payment details", newPaymentDetails);
    //close modal
    // setIsClosing(true);
  };

  //loader settings
  const [submissionState, setSubmissionState] = useState("idle"); // 'idle', 'loading', 'complete', 'failed'
  const [failureMessage, setFailureMessage] = useState("Payment was not completed. Please try again or contact support.");

  useEffect(() => {
    console.log("Submission state changed:", submissionState);
  }, [submissionState]);

  const handleInputFocus = (event) => {
    event.stopPropagation();
    // Delay to allow keyboard to appear
    setTimeout(() => {
      event.target.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 300);
  };

  return (
    <div style={payWindowContainer} ref={modalRef}>
      <div style={payWindow}>
        <div
          style={shape}
          onClick={() => {
            //close modal
            setIsClosing(true);
          }}
        ></div>

        {submissionState === "loading" ? (
          <>
            <div style={titleAndText}>
              {paymentMethodSelected === "STK_PUSH"
                ? "Check your phone for M-Pesa prompt..."
                : "Processing payment..."}
            </div>
            <div className="loading-container" style={{ padding: "0px" }}>
              <div className="loader"></div>
            </div>
            {paymentMethodSelected === "STK_PUSH" && (
              <div
                style={{ ...text, textAlign: "center", margin: "10px 20px" }}
              >
                Please complete the payment on your phone. Waiting for
                confirmation...
              </div>
            )}
          </>
        ) : submissionState === "complete" ? (
          <div className="complete-container">
            <div
              className="complete-animation"
              style={{ ...titleAndText, color: "#28a745" }}
            >
              Payment Successful!
            </div>
            <div
              style={{
                ...text,
                textAlign: "center",
                color: "#28a745",
                margin: "10px 20px",
              }}
            >
              Your payment has been processed successfully.
            </div>
          </div>
        ) : submissionState === "failed" ? (
          <div
            className="error-container"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              className="error-animation"
              style={{ ...titleAndText, color: "#dc3545" }}
            >
              Payment Failed
            </div>
            <div
              style={{
                ...text,
                textAlign: "center",
                color: "#dc3545",
                margin: "10px 20px",
              }}
            >
              {failureMessage}
            </div>
            <button
              style={{
                ...continueButton,
                backgroundColor: "#dc3545",
                marginTop: "10px",
              }}
              onClick={() => {
                setSubmissionState("idle");
                // makePayment();
              }}
            >
              Try Again
            </button>
          </div>
        ) : (
          <>
            {!paymentTypeSelected && (
              <>
                <div style={titleAndText}>
                  Make Payment
                  <div style={text}>
                    Make Payment for invoice IN{invoices[0]?.id.slice(10, 15)}{" "}
                    due
                    <br />
                    {invoices[0]?.dueDate}
                  </div>
                </div>
              </>
            )}

            {!paymentTypeSelected && (
              <>
                <div style={paymentInformationBox}>
                  <div style={paymentInformationTitle}>Transaction Details</div>
                  {!fieldToShow && (
                    <>
                      {Object.keys(InvoiceData.details).map((key) => (
                        <div style={paymentInformationDetails} key={key}>
                          <div>{key}</div>
                          <div style={amountStyle}>
                            ksh {InvoiceData.details[key]}
                          </div>
                        </div>
                      ))}
                      <div style={borderLines}></div>
                      <div style={paymentInformationDetails}>
                        Total Payable Amount
                        <div style={totalPayableAmount}>
                          ksh {InvoiceData.details.Total}
                        </div>
                      </div>
                      <div style={borderLines}></div>
                      <div style={paymentInformationDetails}></div>
                    </>
                  )}
                  {/* check field to show and display appropriate field only */}
                  {fieldToShow[0] === "rent" && (
                    <>
                      <div style={paymentInformationDetails}>
                        <div>Rent</div>
                        <div style={amountStyle}>
                          ksh {InvoiceData.details.Rent}
                        </div>
                      </div>
                    </>
                  )}
                  {fieldToShow[0] === "water" && (
                    <>
                      <div style={paymentInformationDetails}>
                        <div>Water</div>
                        <div style={amountStyle}>
                          ksh {InvoiceData.details.Water}
                        </div>
                      </div>
                    </>
                  )}
                  {fieldToShow[0] === "arrears" && (
                    <>
                      <div style={paymentInformationDetails}>
                        <div>Arrears</div>
                        <div style={amountStyle}>
                          ksh {InvoiceData.details.Arrears}
                        </div>
                      </div>
                    </>
                  )}
                  {fieldToShow[0] === "serviceCharge" && (
                    <>
                      <div style={paymentInformationDetails}>
                        <div>Service Charge</div>
                        <div style={amountStyle}>
                          ksh {InvoiceData.details.Fees}
                        </div>
                      </div>
                    </>
                  )}
                  {fieldToShow[0] === "unpaidDeposit" && (
                    <>
                      <div style={paymentInformationDetails}>
                        <div>Unpaid Deposit</div>
                        <div style={amountStyle}>
                          ksh {InvoiceData.details.UnpaidDeposit}
                        </div>
                      </div>
                    </>
                  )}
                  {fieldToShow[0] === "garbage" && (
                    <>
                      <div style={paymentInformationDetails}>
                        <div>Garbage</div>
                        <div style={amountStyle}>
                          ksh {InvoiceData.details.Garbage}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
            {!paymentTypeSelected && (
              <>
                <div
                  style={paymentTypeSelect}
                  onClick={() => handlePaymentSelect("fullPayment")}
                >
                  <div style={icon}>
                    <MdCreditScore fontSize={25} />
                  </div>
                  <div style={paymentSelectTitleAndText}>
                    <div>Payment in Full</div>
                    <div style={paymentSelectText}>Make a full Payment</div>
                  </div>
                  <input
                    onFocus={handleInputFocus}
                    type="radio"
                    id="fullPayment"
                    name="paymentType"
                    value="fullPayment"
                    style={radialSelect}
                    checked={selectedPaymentType === "fullPayment"}
                    readOnly
                  />
                </div>
                <div
                  style={paymentTypeSelect}
                  onClick={() => handlePaymentSelect("partialPayment")}
                >
                  <div style={icon}>
                    <FaPercentage fontSize={25} />
                  </div>
                  <div style={paymentSelectTitleAndText}>
                    <div>Partial & Advance</div>
                    <div style={paymentSelectText}>Make a partial Payment</div>
                  </div>
                  <input
                    onFocus={handleInputFocus}
                    type="radio"
                    id="partialPayment"
                    name="paymentType"
                    value="partialPayment"
                    style={radialSelect}
                    checked={selectedPaymentType === "partialPayment"}
                    readOnly
                  />
                </div>
              </>
            )}

            {!paymentTypeSelected && (
              <>
                <button
                  style={continueButton}
                  onClick={() => handleContinueToPayment()}
                >
                  Continue
                </button>
              </>
            )}
            {paymentMethodPage && (
              <>
                <div style={titleAndText}>
                  Select Payment Method
                  <div style={text}>Select a payment method to proceed</div>
                </div>

                {/* <PaymentCard
                  iconType={"1"}
                  mainTitle={"Mpesa Paybill"}
                  subText={"Pay via our paybill number"}
                  handleOnclick={handlePaymentMethodSelect}
                  valueToSet={"PAYBILL"}
                  closeThisOne={paymentMethodSelected !== "PAYBILL"}
                  setPaymentReferenceParent={setPaymentReference}
                  setPaymentNarrationParent={setPaymentNarration}
                  setPaymentDateParent={setPaymentDate}
                /> */}
                <PaymentCard
                  iconType={"2"}
                  mainTitle={"Lipa na Mpesa"}
                  subText={"Get an STK push to your phone"}
                  handleOnclick={handlePaymentMethodSelect}
                  valueToSet={"STK_PUSH"}
                  closeThisOne={paymentMethodSelected !== "STK_PUSH"}
                  requiresPhoneNumber={true}
                  setPhoneNumberParent={setPhoneNumber}
                  setPaymentNarrationParent={setPaymentNarration}
                  setPaymentDateParent={setPaymentDate}
                />

                {paymentMethodSelected === "PAYBILL" && (
                  <div style={{
                    backgroundColor: 'white',
                    borderRadius: '15px',
                    padding: '20px',
                    marginTop: '20px',
                    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.28)',
                    width: '90%'
                  }}>
                    <div style={{
                      color: '#192A3A',
                      fontSize: '18px',
                      fontWeight: '600',
                      marginBottom: '15px',
                      textAlign: 'center'
                    }}>
                      How to Pay via Paybill
                    </div>
                    <div style={{
                      color: '#192A3A',
                      fontSize: '14px',
                      lineHeight: '1.6'
                    }}>
                      <p style={{ marginBottom: '10px', color: '#555' }}>On a Safaricom line:</p>
                      <ol style={{ paddingLeft: '20px', margin: '10px 0' }}>
                        <li style={{ marginBottom: '10px' }}>Go to <strong>M-PESA</strong> menu</li>
                        <li style={{ marginBottom: '10px' }}>Select <strong>Lipa na M-PESA</strong></li>
                        <li style={{ marginBottom: '10px' }}>Select <strong>Paybill</strong></li>
                        <li style={{ marginBottom: '10px' }}>
                          Business Number: <span style={{
                            backgroundColor: '#b39359',
                            color: 'white',
                            padding: '3px 8px',
                            borderRadius: '4px',
                            fontWeight: '600',
                            fontFamily: 'Courier New, monospace'
                          }}>4097597</span>
                        </li>
                        <li style={{ marginBottom: '10px' }}>
                          Account Number: <span style={{
                            backgroundColor: '#b39359',
                            color: 'white',
                            padding: '3px 8px',
                            borderRadius: '4px',
                            fontWeight: '600',
                            fontFamily: 'Courier New, monospace'
                          }}>{`${user?.data?.house?.property_account_number}#${user?.data?.house?.house_number || 'YOUR_HOUSE'}`}</span>
                        </li>
                        <li style={{ marginBottom: '10px' }}>
                          Amount: <span style={{
                            backgroundColor: '#65a270',
                            color: 'white',
                            padding: '3px 8px',
                            borderRadius: '4px',
                            fontWeight: '600'
                          }}>
                            KSh {selectedPaymentType === "fullPayment" 
                              ? InvoiceData.details.Total 
                              : partialPaymentDetails?.totalAmount || 0}
                          </span>
                        </li>
                        <li style={{ marginBottom: '10px' }}>Enter M-PESA PIN & confirm</li>
                      </ol>
                      <div style={{
                        backgroundColor: '#fff3cd',
                        borderLeft: '4px solid #b39359',
                        padding: '12px',
                        marginTop: '15px',
                        borderRadius: '4px',
                        fontSize: '13px'
                      }}>
                        <strong style={{ color: '#856404' }}>Important:</strong> Include your house number at the end of the account number.
                      </div>
                    </div>
                  </div>
                )}

                {paymentMethodSelected !== "PAYBILL" && (
                  <div
                    style={{
                      ...paymentTypeSelect,
                      flexDirection: 'column',
                      height: 'auto',
                      padding: '15px',
                      alignItems: 'flex-start'
                    }}
                    onClick={() => handlePaymentMethodSelect("PAYBILL")}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={icon}>
                          <FaMoneyBillWave fontSize={25} />
                        </div>
                        <div style={{ ...paymentSelectTitleAndText, marginLeft: '10px', textAlign: 'left' }}>
                          <div>Paybill</div>
                          <div style={paymentSelectText}>Pay via M-PESA Paybill</div>
                        </div>
                      </div>
                      <input
                        onFocus={handleInputFocus}
                        type="radio"
                        id="paybill"
                        name="paymentMethod"
                        value="PAYBILL"
                        style={radialSelect}
                        checked={paymentMethodSelected === "PAYBILL"}
                        readOnly
                      />
                    </div>
                  </div>
                )}

                {/* <PaymentCard
                  iconType={"3"}
                  mainTitle={"Bank Transfer"}
                  subText={"Pay directly to our bank"}
                  handleOnclick={handlePaymentMethodSelect}
                  valueToSet={"BANK_TRANSFER"}
                  closeThisOne={paymentMethodSelected !== "BANK_TRANSFER"}
                  setPaymentReferenceParent={setPaymentReference}
                  setPaymentNarrationParent={setPaymentNarration}
                  setPaymentDateParent={setPaymentDate}
                />

                <PaymentCard
                  iconType={"4"}
                  mainTitle={"Cash"}
                  subText={"Pay by an in person cash deposit"}
                  handleOnclick={handlePaymentMethodSelect}
                  valueToSet={"CASH"}
                  closeThisOne={paymentMethodSelected !== "CASH"}
                  setPaymentReferenceParent={setPaymentReference}
                  setPaymentNarrationParent={setPaymentNarration}
                  setPaymentDateParent={setPaymentDate}
                /> */}

                {paymentMethodSelected !== "PAYBILL" && (
                <button style={continueButton} onClick={() => makePayment()}>
                  Continue
                </button>
                )}
                {paymentMethodSelected === "PAYBILL" && (
                <button style={{...continueButton, backgroundColor: '#65a270'}} onClick={() => {
                  setIsClosing(true);
                  setTimeout(() => setShowPay(false), 800);
                }}>
                  Done
                </button>
                )}
              </>
            )}
            {partialPaymentPage && (
              <>
                <div style={titleAndText}>
                  Edit Payment Ammount
                  <div style={text}>Insert the ammount to pay</div>
                </div>

                <PartialPaymentPage
                  fieldToShow={fieldToShow}
                  InvoiceData={invoicesReceived?.[0]}
                  summerizedInvoice={InvoiceData}
                  onComplete={onPartialPaymentFormComplete}
                />
              </>
            )}
          </>
        )}
      </div>
      <style jsx>{`
        @keyframes slideUp {
          from {
            transform: translateY(100%);
          }
          to {
            transform: translateY(0);
          }
        }
        @keyframes slideDown {
          from {
            transform: translateY(0);
          }
          to {
            transform: translateY(100%);
          }
        }
      `}</style>
    </div>
  );
};

function formatDueDate(dateString) {
  if (!dateString) return "no due date";

  const date = new Date(dateString);
  const dayOfWeek = date.toLocaleDateString("en-GB", { weekday: "long" });
  const day = date.getDate();
  const month = date.toLocaleDateString("en-GB", { month: "long" });
  const year = date.getFullYear();

  // Format the day with the correct suffix
  const dayWithSuffix =
    day +
    (day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
      ? "nd"
      : day % 10 === 3 && day !== 13
      ? "rd"
      : "th");

  return `${dayOfWeek} ${dayWithSuffix} ${month} ${year}`;
}

function transformInvoices(invoices) {
  console.log("received these invoices", invoices);

  return invoices
    .filter((invoice) => invoice?.payment_status !== "fully_paid") // Filter out fully paid invoices
    .map((invoice) => {
      // Determine the status
      const status =
        invoice?.payment_status === "fully_paid" ? "Paid" : "Unpaid";

      return {
        id: `${(invoice?.invoice_id || "").padStart(3, "0")}`, // Format ID with leading zeros
        status: status,
        dueDate: formatDueDate(invoice?.due_date), // Format the due date
        totalAmount: invoice?.remaining_balance,
        rent: invoice?.remaining_rent || "0",
        water: invoice?.remaining_water || "0",
        garbage: invoice?.remaining_garbage || "0",
        arrears: invoice?.remaining_arrears || "0",
        unpaid_deposit: invoice?.remaining_unpaid_deposit || "0",
        otherCharges: (
          parseFloat(invoice?.remaining_service_charge || 0) +
          parseFloat(invoice?.remaining_late_fee || 0)
        ).toFixed(2),
        totalPayable: invoice?.remaining_balance,
      };
    });
}

function formatDate(year, month, day) {
  // Pad month and day with leading zeros if they are less than 10
  const formattedMonth = month.toString().padStart(2, "0");
  const formattedDay = day.toString().padStart(2, "0");

  // Return the formatted date as YYYY-MM-DD
  return `${year}-${formattedMonth}-${formattedDay}`;
}

export default PayWindowModal;
